function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.333,0A11.333,11.333,0,1,0,22.667,11.333,11.346,11.346,0,0,0,11.333,0Zm0,20.911a9.578,9.578,0,1,1,9.578-9.578A9.589,9.589,0,0,1,11.333,20.911Z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.404 5.623)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M235.705,125.909a.943.943,0,0,0-.944.944v5.665a.944.944,0,0,0,1.888,0v-5.665A.943.943,0,0,0,235.705,125.909Z",
  transform: "translate(-234.761 -125.909)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 9.535)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M236.574,341.87a.88.88,0,0,0-.2-.312.9.9,0,0,0-.151-.113,1.023,1.023,0,0,0-.34-.142.943.943,0,0,0-.849.255.882.882,0,0,0-.2.312.89.89,0,0,0,0,.718.851.851,0,0,0,.51.51.888.888,0,0,0,.717,0,1.1,1.1,0,0,0,.312-.2,1.091,1.091,0,0,0,.2-.312.89.89,0,0,0,0-.718Z",
  transform: "translate(-234.762 -341.284)"
})));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.667,
    height: 22.667,
    viewBox: "0 0 22.667 22.667",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.6423f224.svg";
export { ForwardRef as ReactComponent };